
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giveback",
      function () {
        return require("private-next-pages/giveback.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giveback"])
      });
    }
  